import { useCallback, useEffect, useRef, useState } from "react";

// Apply incoming navigation before rendering or notifying a parent. Mirroring
// initialTab in one effect and reporting the old tab in another can rewrite a
// newer route and make the two views repeatedly replace each other.
export default function useProfileTab(initialTab, normalizeTab, onTabChange) {
  const requested = normalizeTab(initialTab);
  const requestedRef = useRef(requested);
  requestedRef.current = requested;
  const [selection, setSelection] = useState({ requested, value: requested });
  if (selection.requested !== requested) {
    setSelection({ requested, value: requested });
  }
  const tab = selection.requested === requested ? selection.value : requested;
  const callbackRef = useRef(onTabChange);
  useEffect(() => { callbackRef.current = onTabChange; }, [onTabChange]);
  useEffect(() => { callbackRef.current?.(tab); }, [tab]);

  const setTab = useCallback(value => {
    setSelection(previous => ({
      requested: requestedRef.current,
      value: normalizeTab(typeof value === "function" ? value(previous.value) : value),
    }));
  }, [normalizeTab]);
  return [tab, setTab];
}
